import { render, staticRenderFns } from "./NameBadge.vue?vue&type=template&id=5b637c97&scoped=true"
import script from "./NameBadge.vue?vue&type=script&lang=js"
export * from "./NameBadge.vue?vue&type=script&lang=js"
import style0 from "./NameBadge.vue?vue&type=style&index=0&id=5b637c97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b637c97",
  null
  
)

export default component.exports